<template>
    <label
        class="kgr-inputGroup"
        :class="{ 'kgr-inputGroup--inline': inline }"
    >
        <div class="kgr-inputGroup__label">
            {{ $t('kindergarten.feeTable.billOfFees.choose') }}
        </div>
        <kgr-generic-select
            no-null-option
            :options="options"
            :value="valueToOption()"
            @post-input="update($event)"
        />
    </label>
</template>

<script>
import GenericSelect from './GenericSelect.vue'

export default {
    components: {
        'kgr-generic-select': GenericSelect
    },
    props: {
        value: {
            type: Boolean,
            required: true,
        },
        inline: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            options: [
                this.$t('kindergarten.feeTable.billOfFees.cost'),
                this.$t('kindergarten.feeTable.billOfFees.fees'),
            ],
        }
    },
    methods: {
        update(value) {
            const state = value === this.options[1];
            this.$emit('input', state);
            this.$nextTick(() => {
                this.$emit('post-input', state);
            });
        },
        valueToOption() {
            return this.value ? this.options[1] : this.options[0];
        },
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>

